<div class="spinner-container">
    <mat-spinner class="spinner-container-element"></mat-spinner>
</div>